import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa'; // Import social media icons
import ProfileDropdown from './auth/ProfileDropDown';

export default function Footer() {
  const { user } = useSelector((state) => state.profile);

  return (
    <div id="footer" className="bg-richblack-800 p-6">
      <div className="container-fluid" id="containerdiv">
        <div className="flex lg:flex-row flex-col justify-between lg:items-center">
          <div className="flex flex-col text-center" id="itemscontainer">
            <h5 id="heading" className="text-[#B08B24] text-3xl font-norwester text-[1.5rem] pt-3">
              Mehendi Dreams
            </h5>
            <span
              id="text-heading"
              className="text-[#B08B24] mt-2 font-bold text-[1rem] font-roboto"
            >
              CONNECT
            </span>
            
            <div className="flex justify-center gap-4 mt-4">
              <a
                href="https://www.instagram.com/mehendidreams_1?igsh=ZXd1OTJsbGlwYnA4"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#B08B24]"
              >
                <FaInstagram size={24} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61568819458266&mibextid=ZbWKwL"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#B08B24]"
              >
                <FaFacebookF size={24} />
              </a>
              <a
                href="https://youtube.com/@mehendidreams?si=McExnmbFr4mro69a"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white hover:text-[#B08B24]"
              >
                <FaYoutube size={24} />
              </a>
            </div>
            <br />
            <span
              id="text-heading"
              className="text-bold text-[#B08B24] mb-2 font-bold"
            >
              RING
            </span>
            
            <div className="text-white">
              <i>+91 73035 72367</i>
              <br />
              <i>+91 89204 40568</i>
              <br />
              
              <span
                id="text-heading"
                className="text-[#B08B24] mt-3 font-bold"
              >
                GMAIL
              </span>
              <br />
              <i>sumitkumar1998aug@gmail.com</i>
            </div>
          </div>

          <div className="flex flex-row gap-x-10">
            <div className="flex flex-col gap-y-2 text-white">
              <br />
              <br />
              <span className="text-[#B08B24] font-bold">OUR SERVICES</span>
              <i>Bridal Mehandi</i>
              <i>Stylish Mehandi</i>
              <i>Arabic Mehandi</i>
              <i>Heavy Mehandi</i>
              <i>Rajasthani Mehandi</i>
              <i>Marwadi Mehandi</i>
              <i>Bridal Mehandi</i>
            </div>

            <div className="flex flex-col gap-y-2 text-white">
              <br />
              <br />
              <span
                id="text-heading"
                className="font-bold text-[#B08B24]"
              >
                OUR LINKS
              </span>
              <Link to="/" id="footerlinks">
                HOME
              </Link>
              <Link to="/aboutus" id="footerlinks">
                ABOUT ME
              </Link>
              <Link to="/gallery" id="footerlinks">
                SERVICES
              </Link>
              <Link to="/gallary" id="footerlinks">
                WORK
              </Link>
              <Link to="/contact" id="footerlinks">
                CONTACT US
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-y-2">
            <br />
            <br />
            <span
              id="text-heading"
              className="text-[#B08B24] font-bold"
            >
              ADDRESS
            </span>
            <p className="text-white">
              We provide on-location service in India
            </p>
            <input
              type="input"
              className="form-control px-2 p-1 rounded-lg"
              id="form-control"
              aria-describedby="emailHelp"
              placeholder="Drop your number"
            />
            <button
              id="btn"
              className="bg-caribbeangreen-200 font-bold rounded-lg text-white w-24"
            >
              SUBMIT
            </button>

            <div className="mt-10">
              {user?.accountType === 'Admin' ? (
                <ProfileDropdown />
              ) : (
                <Link to="/login">
                  <button className="w-40 h-12 rounded-xl border border-blue-300 text-blue-300 hover:text-white hover:bg-blue-300">
                    Admin Login
                  </button>
                </Link>
              )}
             {/* defjghyijghijbgxcdfdsssdsdb */}
            </div>
          </div>
        </div>

        <div className="py-2 text-white flex text-center" id="text">
          <h5>© 2023 Mehendi Dreams</h5>
          <br/>
          <a href="https://agkraft.in" target="_blank" rel="noopener noreferrer" className="text-[#B08B24] hover:text-white hover:underline">
          <h2 className='text-[#f39e3e] ml-2'> Website Developed by AGKRAFT.in</h2>
          </a>
        </div>
      </div>
    </div>
  );
}
